"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3Urls = void 0;
var S3Urls = (function () {
    function S3Urls(s3Host, lsLng) {
        if (s3Host === void 0) { s3Host = process.env.REACT_APP_S3; }
        if (lsLng === void 0) { lsLng = 'i18nextLng'; }
        this.s3Host = s3Host;
        this.lsLng = lsLng;
    }
    S3Urls.prototype.getFallbackLng = function (lng) {
        return lng === 'en' ? 'ru' : 'en';
    };
    Object.defineProperty(S3Urls.prototype, "lng", {
        get: function () {
            var _a;
            return (_a = localStorage.getItem(this.lsLng)) !== null && _a !== void 0 ? _a : 'ru';
        },
        enumerable: false,
        configurable: true
    });
    S3Urls.prototype.documentUrl = function (document, ext) {
        if (ext === void 0) { ext = 'pdf'; }
        return "".concat(this.s3Host, "/documents/").concat(document, ".").concat(ext);
    };
    Object.defineProperty(S3Urls.prototype, "support", {
        get: function () {
            if (this.lng === 'ru')
                return "https://drive.google.com/file/d/18AavFDDM2y956ZF6y8dxHtYyGh7pt4Es/view?usp=sharing";
            if (this.lng === 'en')
                return "https://podprogramma.notion.site/Support-68682d2cfa7c451b833bf51f42fcfa27";
            if (this.lng === 'pt')
                return "https://podprogramma.notion.site/Apoio-9956cdafb08e4966973dd30c5285302c";
            if (this.lng === 'es')
                return "https://podprogramma.notion.site/Apoyo-eff932ef6c2c47a5b44735f0a3592f15";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "privacyPolicyRU", {
        get: function () {
            return this.documentUrl('ru/privacy-policy');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "privacyPolicyEN", {
        get: function () {
            return this.documentUrl('en/privacy-policy');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "termsOfUseRU", {
        get: function () {
            return this.documentUrl('ru/terms-of-use');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "termsOfUseEN", {
        get: function () {
            return this.documentUrl('en/terms-of-use');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "consultationsOfferRU", {
        get: function () {
            return this.documentUrl('ru/consultations-offer');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "onlinePaymentsRU", {
        get: function () {
            return this.documentUrl('ru/online-payments');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "privacyPolicyKZ", {
        get: function () {
            return this.documentUrl('kz/privacy-policy');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "termsOfUseKZ", {
        get: function () {
            return this.documentUrl('kz/terms-of-use');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "consultationsOfferKZ", {
        get: function () {
            return this.documentUrl('kz/consultations-offer');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(S3Urls.prototype, "mailingAgreementRU", {
        get: function () {
            return this.documentUrl('ru/mailing-agreement');
        },
        enumerable: false,
        configurable: true
    });
    return S3Urls;
}());
exports.S3Urls = S3Urls;
